"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuid = exports.deleteAuidCookie = exports.fetchAuid = exports.ACCOUNT_BASE_URL = exports.EXPIRATION_DAYS = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// 5 minutes in days
var EXPIRATION_DAYS = 5 / 1440;
exports.EXPIRATION_DAYS = EXPIRATION_DAYS;
var ACCOUNT_BASE_URL;
exports.ACCOUNT_BASE_URL = ACCOUNT_BASE_URL;

(function (ACCOUNT_BASE_URL) {
  ACCOUNT_BASE_URL["PROD"] = "https://account.mongodb.com";
  ACCOUNT_BASE_URL["QA"] = "https://account-qa.mongodb.com";
  ACCOUNT_BASE_URL["DEV"] = "https://account-dev.mongodb.com";
  ACCOUNT_BASE_URL["LOCAL"] = "http://localhost:8080";
  ACCOUNT_BASE_URL["E2E"] = "http://localhost:9080";
})(ACCOUNT_BASE_URL || (exports.ACCOUNT_BASE_URL = ACCOUNT_BASE_URL = {}));

var fetchAuid = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (environment) {
    return fetch("".concat(ACCOUNT_BASE_URL[environment], "/account/profile/userAuid"), {
      credentials: 'include',
      method: 'GET'
    }).then(r => r.json());
  });

  return function fetchAuid(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchAuid = fetchAuid;

var deleteAuidCookie = () => {
  _jsCookie.default.remove(_types.COOKIE_KEYS.AUID, {
    domain: window.location.hostname
  });
}; // Method to retrieve AUID from subdomain cookie or account resource


exports.deleteAuidCookie = deleteAuidCookie;

var getAuid = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (environment) {
    var shouldRequestAuid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var canSetAuidCookie = arguments.length > 2 ? arguments[2] : undefined;

    // Check if already in cookie
    var auidCookie = _jsCookie.default.get(_types.COOKIE_KEYS.AUID);

    if (auidCookie) {
      return auidCookie;
    }

    if (!shouldRequestAuid) {
      return null;
    }

    var auidResponse;

    try {
      // Fetch account resource if not present in cookie
      var {
        userAuid
      } = yield fetchAuid(environment);

      if (!userAuid) {
        throw new Error('User auid is undefined.');
      }

      auidResponse = userAuid;

      if (canSetAuidCookie) {
        // Store cookie on subdomain level
        _jsCookie.default.set(_types.COOKIE_KEYS.AUID, userAuid, {
          domain: window.location.hostname,
          expires: EXPIRATION_DAYS
        });
      }
    } catch (e) {
      // Return anonymousId if error occurs
      console.error('failed to retrieve auid', e);
      return null;
    }

    return auidResponse;
  });

  return function getAuid(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getAuid = getAuid;
//# sourceMappingURL=auid.js.map